export enum ReferralStatus {
  Registered = 'registered',
  UploadedDocuments = 'uploadedDocuments',
  Hired = 'hired',
  Unqualified = 'unqualified',
}
